import { WifiProfile } from '../../stores/TelematicsDevice/DeviceStateApi';
import { NearbyWifiNetwork } from '../../stores/TelematicsDevice/DeviceTelemetryApi';

export interface NewProfile {
  ssid: string;
  securityType: string;
  password: string;
  hiddenSsid: boolean;
}

export const SECURITY_TYPES = [
  { value: 'AUTOMATIC', label: 'Automatic' },
  { value: 'WPA_PSK', label: 'WPA' },
  { value: 'WPA2_PSK', label: 'WPA2 PSK' },
  { value: 'WPA3_PSK', label: 'WPA3 PSK' },
  { value: 'OPEN', label: 'Open (No Security)' },
];

export const INITIAL_PROFILE: NewProfile = {
  ssid: '',
  securityType: 'AUTOMATIC',
  password: '',
  hiddenSsid: false,
};

export const MIN_WIFI_FIRMWARE = { major: 2, minor: 5, patch: 12 } as const;
export const MIN_WIFI_FIRMWARE_LABEL = `${MIN_WIFI_FIRMWARE.major}.${MIN_WIFI_FIRMWARE.minor}.${MIN_WIFI_FIRMWARE.patch}`;
export const FIRMWARE_REQUIREMENT_MESSAGE = `Managing Wi-Fi networks requires firmware version ${MIN_WIFI_FIRMWARE_LABEL} or higher.`;

export const mapScannedNetworkSecurityType = (securityType?: string): string => {
  const normalizedSecurityType = (securityType || '').toUpperCase().replace(/[\s-]/g, '_');

  if (normalizedSecurityType.indexOf('OPEN') >= 0 || normalizedSecurityType.indexOf('NONE') >= 0) {
    return 'OPEN';
  }
  if (normalizedSecurityType.indexOf('WPA3') >= 0) {
    return 'WPA3_PSK';
  }
  if (normalizedSecurityType.indexOf('WPA2') >= 0) {
    return 'WPA2_PSK';
  }
  if (normalizedSecurityType.indexOf('WPA') >= 0) {
    return 'WPA_PSK';
  }
  return 'AUTOMATIC';
};

export const getSecurityTypeLabel = (securityType?: string): string => {
  const securityTypeOption = SECURITY_TYPES.find(type => type.value === securityType);
  return securityTypeOption ? securityTypeOption.label : 'Automatic';
};

export const formatScannedNetworkSummary = (network: NearbyWifiNetwork): string => {
  const securityType = mapScannedNetworkSecurityType(network.securityType);
  const rssiText = network.rssi !== undefined ? `${network.rssi} dBm` : undefined;
  return [getSecurityTypeLabel(securityType), rssiText].filter(Boolean).join(' - ');
};

export const buildWifiProfile = (draft: NewProfile): WifiProfile => {
  const profile: WifiProfile = {
    ssid: draft.ssid.trim(),
    securityType: draft.securityType,
    hiddenSsid: draft.hiddenSsid,
  };

  if (draft.password.trim()) {
    profile.password = draft.password.trim();
  }

  return profile;
};

export const isOpenSecurity = (securityType: string): boolean => securityType === 'OPEN';
